import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";

import DesktopMenu from "./deskTopMenu";
import MobileMenu from "./mobileMenu";
import { MenuContainer } from "./styles";

const MenuList = [
  ["Home", "/"],
  ["Features", "/features"],
  ["Tokenomics", "/tokenomics"],
  ["Medium", "https://hexvoltinu.medium.com/hexvoltinu-power-up-your-next-moonshot-b7677d7b4d97"],
  ["Join Telegram", "https://t.me/HexVoltInuportal"],
];
const checkSticky = "";
const Menu = () => {
  // const [useCheckSticky, setCheckSticky] = useState("no-sticky");
  // useEffect(() => {
  //   window.addEventListener("scroll", isSticky);
  //   return () => {
  //     window.removeEventListener("scroll", isSticky);
  //   };
  // });
  // const isSticky = (e) => {
  //   const scrollTop = window.scrollY;
  //   scrollTop >= 20 ? setCheckSticky("sticky") : setCheckSticky("No-sticky");
  // };
  return (
    <MenuContainer>
      <DesktopMenu menuList={MenuList} />
      <MobileMenu menuList={MenuList} />
    </MenuContainer>
  );
};

export default Menu;
